import { useState } from "react";

// Mails d'un fournisseur : le premier de la liste est le mail principal ; un doublon n'est pas ajouté.
export function SupplierEmailsEditor({ emails, onChange, fieldStyle }) {
    const [newEmail, setNewEmail] = useState("");

    const addEmail = () => {
        const email = newEmail.trim().toLowerCase();
        if (!email || emails.some(existing => existing.toLowerCase() === email)) return;
        onChange([...emails, email]);
        setNewEmail("");
    };

    const removeEmail = (index) => {
        onChange(emails.filter((_, currentIndex) => currentIndex !== index));
    };

    return (
        <div
            role="group"
            aria-label="Mails fournisseur"
            style={{
                background: "white",
                border: "2px dashed #e5e7eb",
                borderRadius: "8px",
                padding: "12px",
            }}
        >
            <p style={{ margin: "0 0 10px", fontSize: "11px", fontWeight: 800, color: "#1d4ed8", textTransform: "uppercase", letterSpacing: "0.5px" }}>
                Mails fournisseur <span style={{ fontWeight: 500, opacity: 0.7 }}>({emails.length})</span>
            </p>
            <div style={{ display: "flex", flexDirection: "column", gap: "5px", minHeight: "34px", maxHeight: "170px", overflowY: "auto", marginBottom: "10px" }}>
                {emails.length === 0 && (
                    <span style={{ fontSize: "12px", color: "#9ca3af", fontStyle: "italic" }}>
                        Aucun email ajouté
                    </span>
                )}
                {emails.map((email, index) => (
                    <div
                        key={`${email}-${index}`}
                        style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            gap: "8px",
                            background: "#f8fafc",
                            border: "1px solid #e5e7eb",
                            borderRadius: "6px",
                            padding: "6px 8px",
                            fontSize: "13px",
                            color: "#374151",
                        }}
                    >
                        <span style={{ minWidth: 0, overflow: "hidden", textOverflow: "ellipsis" }}>
                            {email}
                            {index === 0 && (
                                <span style={{ marginLeft: "7px", fontSize: "11px", color: "#1d4ed8", fontWeight: 700 }}>
                                    principal
                                </span>
                            )}
                        </span>
                        <button
                            type="button"
                            onClick={() => removeEmail(index)}
                            style={{ background: "none", border: "none", cursor: "pointer", color: "#9ca3af", fontSize: "16px", lineHeight: 1, padding: "0 2px" }}
                            title="Supprimer"
                        >
                            ×
                        </button>
                    </div>
                ))}
            </div>
            <div style={{ display: "flex", gap: "6px" }}>
                <input
                    type="email"
                    aria-label="Ajouter un email fournisseur"
                    placeholder="Ajouter un email..."
                    value={newEmail}
                    onChange={e => setNewEmail(e.target.value)}
                    onKeyDown={e => { if (e.key === "Enter") { e.preventDefault(); addEmail(); } }}
                    style={{ ...fieldStyle, flex: 1 }}
                />
                <button
                    type="button"
                    onClick={addEmail}
                    style={{ padding: "8px 13px", borderRadius: "7px", border: 0, background: "#111827", color: "white", fontWeight: 800, cursor: "pointer" }}
                >
                    +
                </button>
            </div>
        </div>
    );
}
